module.exports = __webpack_public_path__ + "img/sg.cb8124a8.svg";